import PropTypes from 'prop-types';
import React from 'react';
import { Button } from '@amzn/stencil-react-components/button';
import { Spinner, SpinnerSize } from '@amzn/stencil-react-components/spinner';
import { Col } from '@amzn/stencil-react-components/layout';
import noop from 'lodash/noop';

const ButtonWithLoader = ({
  isLoading,
  isPrimary,
  onClickHandler,
  variant,
  children,
  isDisabled = false,
}) => {
  return (
    <Button
      data-testid="save-continue-btn"
      onClick={onClickHandler}
      primary={isPrimary}
      disabled={isDisabled || isLoading}
      variant={variant}
    >
      {children}
      {isLoading && (
        <Col
          gridGap={'S200'}
          flex={1}
          data-testid="spinner-section"
          justifyContent="center"
          alignItems="center"
          style={{ marginLeft: '7px' }}
        >
          <Spinner colorScheme="inverted" size={SpinnerSize.small} />
        </Col>
      )}
    </Button>
  );
};

ButtonWithLoader.defaultProps = {
  isPrimary: true,
  variant: 'primary',
  onClickHandler: noop,
  isLoading: false,
  isDisabled: false,
};

ButtonWithLoader.propTypes = {
  isLoading: PropTypes.bool,
  onClickHandler: PropTypes.func,
  isPrimary: PropTypes.bool,
  variant: PropTypes.string,
};
export default ButtonWithLoader;
